import { render, staticRenderFns } from "./AgendaBar.vue?vue&type=template&id=32900dea"
import script from "./AgendaBar.vue?vue&type=script&lang=js"
export * from "./AgendaBar.vue?vue&type=script&lang=js"
import style0 from "./AgendaBar.vue?vue&type=style&index=0&id=32900dea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports